/**
 * Query Cache Tags
 * Used for cache invalidation by domain
 */
export const queryTags = {
  profile: 'profile',
  auth: 'auth',
  cms: 'cms',
  faq: 'faq',
  product: 'product',
  category: 'category',
  user: 'user',
  coupon: 'coupon',
  subscription: 'subscription',
  permission: 'permission',
  subAdmin: 'subAdmin',
  brand: 'brand',
  banner: 'banner',
  wishlist: 'wishlist',
  store: 'store',
  order: 'order',
  notification: 'notification',
  reward: 'reward',
  transaction: 'transaction',
  media: 'media',
  settings: 'settings',
  workout: 'workout',
  community: 'community',
  badge: 'badge',
  promotion: 'promotion',
  dashboard: 'dashboard',
} as const;

export type QueryTag = typeof queryTags[keyof typeof queryTags];

